// assets/left-thumbs.js
(function () {
  function $(q, root) { return (root || document).querySelector(q); }
  function $all(q, root) { return Array.prototype.slice.call((root || document).querySelectorAll(q)); }
  function click(el){ try{ if(el && typeof el.click==='function'){ el.click(); return true; } }catch(e){} return false; }
  var esc = (window.CSS && CSS.escape) ? CSS.escape : function (s) { return String(s).replace(/([^\w-])/g, '\\$1'); };

  function getScope(){
    return $('.product-information__media') || $('.media-with-left-thumbs') || document;
  }

  function findContainer(scope){
    return (
      $('.flickity-viewport', scope)?.parentElement ||
      $('.swiper', scope) ||
      $('.splide', scope) ||
      $('.glide', scope) ||
      $('[data-product-single-media-group]', scope) ||
      $('.carousel-main', scope) ||
      scope
    );
  }

  function selectViaLibraries(scope, idx){
    var root = findContainer(scope);
    if (!root) return false;

    // Flickity
    var flickityInst = root._flickity || root.flickity || root.__Flickity || root.Flickity;
    if (!flickityInst) {
      // sometimes stored on viewport or slider
      var vp = $('.flickity-viewport', root);
      var wrap = vp ? vp.parentElement : null;
      flickityInst = wrap?._flickity || wrap?.flickity || vp?._flickity || vp?.flickity;
    }
    if (flickityInst && typeof flickityInst.select === 'function') {
      flickityInst.select(idx);
      return true;
    }

    // Swiper
    if (root.swiper && typeof root.swiper.slideTo === 'function') {
      root.swiper.slideTo(idx, 300);
      return true;
    }

    // Splide
    if (root.splide && typeof root.splide.go === 'function') {
      root.splide.go(idx);
      return true;
    }

    // Glide
    if (root._glide && typeof root._glide.go === 'function') {
      root._glide.go('=' + idx);
      return true;
    }

    // Keen Slider
    if (root.keenSlider && typeof root.keenSlider.moveToIdx === 'function') {
      root.keenSlider.moveToIdx(idx);
      return true;
    }

    return false;
  }

  function clickDotsByIndex(scope, idx){
    var picks = [
      '.flickity-page-dots button',
      '.flickity-page-dots li',
      '.slider-buttons [data-slide-index]',
      '.slideshow__controls [data-slide-index]',
      '[role="tablist"] [role="tab"]',
      '.media-gallery__pagination button',
      '.pagination button, .dots button'
    ];
    for (var i=0;i<picks.length;i++){
      var dots = $all(picks[i], scope);
      if (dots.length && dots[idx]) return click(dots[idx]);
    }
    return false;
  }

  function slidesIn(scope){
    var c = findContainer(scope);
    var list = $all('[data-product-single-media-wrapper]', c);
    if (!list.length) list = $all('.carousel-cell, .product-media, [data-media-id]', c);
    return list;
  }

  function scrollToIndex(scope, idx){
    var c =
      $('.flickity-viewport', scope) ||
      $('[data-product-single-media-group]', scope) ||
      $('.carousel-main', scope) ||
      findContainer(scope);

    var list = slidesIn(scope);
    var target = list[idx];
    if (!target || !c) return false;

    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      return true;
    }
    return false;
  }

  function dispatchCommonEvents(scope, id, idx){
    var events = [
      ['media:select', { mediaId: id, index: idx }],
      ['product:media:select', { mediaId: id, index: idx }],
      ['theme:gallery:select', { mediaId: id, index: idx }]
    ];
    events.forEach(function(pair){
      try {
        scope.dispatchEvent(new CustomEvent(pair[0], { bubbles: true, detail: pair[1] }));
        document.dispatchEvent(new CustomEvent(pair[0], { bubbles: true, detail: pair[1] }));
      } catch(e){}
    });
  }
  

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-left-thumbs] .left-thumbs__item');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var scope = getScope();
    var id   = btn.getAttribute('data-media-id') || '';
    var idx  = parseInt(btn.getAttribute('data-index') || '0', 10);

    // 1) try native thumb by media id
    var native =
      scope.querySelector('.js-thumb-item[data-image-id="'+id+'"]') ||
      scope.querySelector('[data-image-id="'+id+'"]') ||
      scope.querySelector('[data-media-id="'+id+'"]') ||
      scope.querySelector('.product-media--'+esc(id));
    if (click(native)) return;

    // 2) try slider library APIs
    if (selectViaLibraries(scope, idx)) return;

    // 3) try dots/pagination at same index
    if (clickDotsByIndex(scope, idx)) return;

    // 4) last resort: scroll visible slide into view
    if (scrollToIndex(scope, idx)) return;

    // 5) nudge any listeners
    dispatchCommonEvents(scope, id, idx);
  }, true);
})();
